module.exports = __webpack_public_path__ + "static/img/case_4.fd429c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_4.jpg
// module id = XLHe
// module chunks = 0